module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_6000.bc670ea0.png";